
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28789",
  depVersions: {
  "payments-ui-app": "static-1.28789",
  "bend-plugin-arboretum": "static-1.2054",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.512",
  "crm_data": "static-4.93273",
  "data-fetching-client": "static-1.10145",
  "emoji-mart": "static-3.9",
  "enviro": "static-4.523",
  "foundations-components": "static-1.8798",
  "foundations-components-legacy": "static-1.1823",
  "head-dlb": "static-1.5330",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6096",
  "hs-test-utils": "static-1.8547",
  "hub-http": "static-1.6710",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11996",
  "I18n": "static-7.1716",
  "jasmine-runner": "static-1.6961",
  "quartz": "static-1.7698",
  "raven": "static-3.6411",
  "react-dlb": "static-1.96",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.123",
  "react-utils": "static-2.5682",
  "reselect": "static-3.18",
  "stripe-js": "static-1.122",
  "ui-components-test-utils": "static-1.6133",
  "UIComponents": "static-3.8942",
  "usage-tracker-public": "static-1.7637",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38108",
  "payments-checkout-lib": "static-1.712",
  "cssUtils": "static-1.1130",
  "customer-data-objects": "static-1.8219",
  "FireAlarmUi": "static-1.4894",
  "foundations-assets": "static-1.5395",
  "foundations-theming": "static-1.4998",
  "graphql": "static-1.95",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12303",
  "icons": "static-2.710",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3389",
  "property-translator": "static-1.5885",
  "quartz-config": "static-1.1476",
  "quartz-core": "static-1.6917",
  "quartz-i18n": "static-1.1373",
  "quartz-routing": "static-1.1128",
  "quartz-tracking": "static-1.1077",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17243",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "redux-toolkit": "static-1.84",
  "ReduxMessenger": "static-2.10878",
  "rpc-client-utils": "static-1.5170",
  "sanitize-text": "static-1.8666",
  "SharedI18nStrings": "static-1.190",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5262",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11653",
  "ui-images": "static-2.1284",
  "usage-tracker-core": "static-1.7676",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3975",
  "quartz-webpack": "static-1.3922",
  "bend-plugin-quartz-routing": "static-1.776",
  "bender-build-tools": "static-1.3622",
  "crm_universal": "static-1.22768",
  "customer-data-email": "static-1.18689",
  "customer-data-ui-utilities": "static-1.10340",
  "dispatcher": "static-1.150",
  "frontend-preferences-client": "static-1.8427",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8266",
  "quick-fetch": "static-1.4247",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5067",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2714",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9936",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.112",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3177",
  "ui-fonts": "static-1.1258",
  "HeadJS": "static-2.830",
  "hs-test-utils-bend-plugin": "static-1.3658",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.419",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4810",
  "foundations-components-test-utils": "static-1.6281",
  "ui-addon-draggable": "static-3.5259",
  "commerce-billing-lib": "static-1.20547",
  "commerce-shared-components-lib": "static-1.19633",
  "commerce-tools-ui-lib": "static-1.11381",
  "crm-message-bus": "static-1.44171",
  "customer-data-objects-ui-components": "static-1.13540",
  "customer-data-properties": "static-1.53159",
  "growth-payments-core": "static-1.26558",
  "ui-addon-iframeable": "static-1.9585",
  "usage-tracker": "static-1.7826",
  "usage-tracker-container": "static-1.7816",
  "sassPrefix": "static-1.391",
  "inbound-db-properties-service-client": "static-1.4168",
  "foundations-theming-base": "static-1.3983",
  "bend-plugin-foundations-theming": "static-1.3481",
  "stylex": "static-1.48",
  "opentelemetry-fe-types": "static-1.300",
  "hub-http-janus": "static-1.914",
  "hubspotter-http": "static-1.4991",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.675",
  "quartz-auth": "static-1.1373",
  "quartz-head": "static-1.1363",
  "quartz-test": "static-1.1373",
  "trellis-components": "static-1.3196",
  "usage-tracker-session-replay": "static-1.5512",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.207",
  "web-vitals": "static-1.21",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.580",
  "chirp-fetch": "static-1.2409",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4974",
  "FormUrlGenerator": "static-2.5219",
  "sequences-lib": "static-1.8827",
  "apollo-link-hub-http": "static-2.5097",
  "FileManagerCore": "static-1.40388",
  "FileManagerLib": "static-1.40529",
  "hubspot-apollo-client": "static-1.5387",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.764",
  "timezone-utils": "static-2.5734",
  "ui-gdpr-components": "static-1.10658",
  "react-dnd-compat": "static-1.5112",
  "stylex-utils": "static-1.183",
  "trellis-theming": "static-1.1528",
  "react-flip-move": "static-1.85",
  "avatar-components": "static-1.2995",
  "hs-resources": "static-1.694",
  "pulse": "static-1.1160",
  "utility-belt": "static-1.3042",
  "zustand": "static-1.91",
  "batch-promise": "static-1.2058",
  "customer-data-associations": "static-1.7846",
  "customer-data-property-utils": "static-1.8561",
  "customer-data-tracking": "static-1.7376",
  "framework-data-table": "static-2.12888",
  "object-builder-ui-client": "static-1.50119",
  "payments-enrollment-embed-lib": "static-1.24311",
  "stripe-embedded-components": "static-1.8292",
  "ui-addon-opt": "static-4.8927",
  "ai-components-ui-library": "static-1.10075",
  "customer-data-rte": "static-1.33953",
  "cv-backend-services": "static-1.1612",
  "file-manager-components": "static-1.24889",
  "growth-onboarding-confetti": "static-1.3566",
  "growth-onboarding-empty-states": "static-1.6583",
  "hubspot-prosemirror": "static-1.19339",
  "InboxConnectUtils": "static-4.15896",
  "payment-link-components": "static-1.24521",
  "payments-post-enroll-local-storage-lib": "static-1.5610",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39221",
  "react-colorpicker": "static-2.10713",
  "ui-addon-upgrades": "static-9.18568",
  "ui-addon-video-player": "static-1.9127",
  "user-context": "static-1.5563",
  "restore-request-side-panel-lib": "static-1.2101",
  "atom": "static-1.5580",
  "reference-resolvers": "static-1.8692",
  "calling-global-api": "static-1.66300",
  "calling-internal-common": "static-1.31828",
  "calling-lifecycle-internal": "static-1.67682",
  "calling-lifecycle-messages": "static-1.59974",
  "commerce-products-lib": "static-1.10989",
  "conditional-properties-service-client": "static-1.4130",
  "crm-index-visualization-core": "static-1.4800",
  "crm-links": "static-1.6821",
  "crm-pipelines-api-client-types": "static-1.4460",
  "customer-data-properties-shared-msw-handlers": "static-1.10282",
  "data-agent-utils": "static-1.979",
  "data-token-picker": "static-1.17183",
  "external-options-client-types": "static-1.4455",
  "formula-editor": "static-1.15053",
  "google-libphonenumber": "static-1.52",
  "inbound-db-meta-service-client": "static-1.3791",
  "inbounddb-objects-service-types": "static-1.4531",
  "meetings-icalendar-utils-lib": "static-1.1140",
  "multi-currency-client-types": "static-1.4025",
  "pipeline-validation-client-types": "static-1.4300",
  "property-value-citations": "static-1.3773",
  "react-tinymce": "static-1.56326",
  "reference-resolvers-lite": "static-1.8619",
  "rich-text-lib": "static-1.20603",
  "smart-data-capture-core": "static-1.545",
  "tiered-pricing": "static-1.2335",
  "tinymce-config": "static-2.55452",
  "tinymce-plugins": "static-1.58566",
  "tinymce-themes": "static-1.57422",
  "topics-actions-lib": "static-1.693",
  "trellis-ext-i18n": "static-1.1432",
  "trial-components-library": "static-1.14435",
  "ui-addon-emoji-picker": "static-1.10371",
  "ui-addon-form-validation": "static-1.11352",
  "laboratory-lib": "static-3.7655",
  "onboarding-scopes": "static-1.6957",
  "seat-types-lib": "static-1.1103",
  "magpie-lib": "static-1.5933",
  "navigation-messaging": "static-1.8556",
  "ts-schema": "static-1.4411",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10955",
  "hubspotter-http-shared-msw-handlers": "static-1.10953",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8684",
  "audio-components": "static-1.6613",
  "breeze-artifacts-sdk": "static-1.1089",
  "ContentUtils": "static-1.69547",
  "copilot-toolkit": "static-1.12209",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30105",
  "FileManagerImages": "static-1.38040",
  "html-to-image": "static-1.67",
  "immerable": "static-1.4647",
  "ui-universal-auth": "static-1.9804",
  "urlinator": "static-1.5022",
  "video-components": "static-1.14501",
  "video-data-lib": "static-1.36157",
  "video-embed": "static-1.36991",
  "hubspot-apollo-cache": "static-1.846",
  "trellis-migration-context": "static-1.86",
  "event-emitter": "static-1.1465",
  "fdsr-migration-layer": "static-1.521",
  "framework-builder-read-service-client": "static-1.4352",
  "bend-plugin-pulse": "static-1.663",
  "fast-json-patch": "static-1.76",
  "customer-data-reference-ui-components": "static-1.13679",
  "reporting-data": "static-1.69494",
  "tasks-actions-lib": "static-1.487",
  "purchase-motions-components": "static-1.6674",
  "growth-onboarding-feedback-components": "static-1.7089",
  "growth-onboarding-reliability": "static-1.5592",
  "marketplace-ui-apps-core": "static-1.19625",
  "onboarding-tours": "static-1.17436",
  "stripe-connect-js": "static-1.85",
  "chatspot-core": "static-1.24072",
  "content-assistance-lib": "static-1.8467",
  "draft-content-plugins": "static-1.29206",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22406",
  "breeze-engine-lib": "static-1.2279",
  "poll-commands": "static-1.3981",
  "video-components-external": "static-1.12499",
  "trellis-story-utils": "static-1.5003",
  "ui-addon-react-router-dom": "static-1.10033",
  "content-media-capture": "static-1.5843",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9602",
  "ui-shepherd-react": "static-3.10790",
  "hub-http-contrib": "static-1.3536",
  "ui-addon-sales-email": "static-1.5711",
  "commerce-tours-lib": "static-1.6906",
  "getting-started-shared-tasks": "static-1.19619",
  "sales-checkout-service-client": "static-1.4030",
  "merchandise-lib": "static-1.288",
  "getting-started-shared-tasks-store": "static-1.18737",
  "onboarding-tours-utils": "static-1.1503",
  "calling-error-reporting": "static-1.31835",
  "shared-worker-versioning": "static-1.11548",
  "calling-usage-tracker": "static-1.7049",
  "conversations-skeleton-state": "static-1.7622",
  "voice-sms-access-library": "static-1.2551",
  "commerce-permissions": "static-1.1291",
  "products-iframe-lib": "static-1.8973",
  "products-ui-components-shared-msw-handlers": "static-1.11337",
  "crm-index-associations-lib": "static-1.6957",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11038",
  "sales-views-client-types": "static-1.4766",
  "framework-data-schema-resolvers": "static-1.7402",
  "location-customization-utils-lib": "static-1.10483",
  "data-agent-kit": "static-1.966",
  "enrichment-settings-lib": "static-1.320",
  "fsm": "static-1.4266",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7310",
  "bark-lib": "static-1.17039",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6403",
  "react-codemirror": "static-1.11148",
  "tinymce": "static-5.11",
  "interframe": "static-3.5247",
  "tinymce-data": "static-1.41537",
  "layout-dnd-components": "static-1.13272",
  "layout-dnd-utils": "static-1.12247",
  "ui-brand-identity-lib": "static-1.17020",
  "NamespacedHubStyle": "static-2.9384",
  "embedded-academy-lib": "static-1.16105",
  "hubs-service-types": "static-1.1771",
  "navigation-components": "static-1.19229",
  "nest": "static-1.742",
  "nudge-client-utils": "static-1.3467",
  "purchase-motions-api": "static-1.6677",
  "signup-constants": "static-1.20010",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5393",
  "reactive-lib": "static-1.1228",
  "simple-logging-lib": "static-1.3555",
  "nav-meta": "static-1.30866",
  "breeze-engine-core": "static-1.1557",
  "cms-field-types": "static-1.5319",
  "content-icons-ui": "static-1.2489",
  "integrations-lib": "static-1.17496",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.368",
  "unified-auth-core-lib": "static-1.1600",
  "social-insights-client-types": "static-1.22982",
  "outpost": "static-1.4638",
  "persist-promise": "static-1.4215",
  "reporting-client-types": "static-1.2867",
  "signup-ui-url-generator": "static-2.8542",
  "developer-experience-shared-components": "static-1.11049",
  "immutable-less": "static-1.5159",
  "marketplace-ui-client-types": "static-1.18500",
  "marketplace-ui-common": "static-1.21093",
  "ui-addon-integrations-directory-panel": "static-2.8458",
  "ui-extensibility-client-types": "static-1.4423",
  "growth-data-modal": "static-1.6175",
  "growth-onboarding-next-action-utils": "static-1.3040",
  "onboarding-tours-client": "static-1.5651",
  "ui-shepherd-tracker": "static-1.8171",
  "ui-coaching-tips": "static-1.29613",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1257",
  "highlight.js": "static-1.92",
  "content-media-composition-data-lib": "static-1.13647",
  "content-media-compositions": "static-2.17654",
  "media-bridge-lib": "static-1.19687",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4934",
  "calling-orchestration-schema": "static-1.37328",
  "framework-data-schema-quick-fetch": "static-1.7307",
  "crm-record-cards-service-types": "static-1.3878",
  "highcharts": "static-8.117",
  "storybook-react": "static-1.46",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16719",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69622",
  "layout-data-lib": "static-1.10572",
  "academy-common-lib": "static-1.15566",
  "nudge-custom-function-registry": "static-1.3224",
  "nudge-renderer-utils": "static-1.3543",
  "whisper-core-api": "static-1.7682",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14911",
  "integrations-tracking-lib": "static-1.6132",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4115",
  "oauth-service-types": "static-1.4644",
  "ai-settings-ui-library": "static-1.8637",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1704",
  "onboarding-data-sync-lib": "static-1.2881",
  "growth-onboarding-next-action-components": "static-1.3068",
  "user-context-client": "static-1.5017",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15865",
  "advanced-menus-lib": "static-1.12607",
  "ExportDialog": "static-6.10880",
  "ui-memberships-settings-lib": "static-1.35263",
  "academy-service-client": "static-1.4200",
  "croppie": "static-2.10",
  "final-form": "static-1.85",
  "SafeStorage": "static-1.4903",
  "trellis-ecosystem": "static-1.7897",
  "wootric-nps": "static-1.7314",
  "universal-page-editor-lib": "static-1.3522",
  "settings-ui-lib": "static-1.13036",
  "simple-data-table": "static-1.3876",
  "meetings-connect-utils-lib": "static-1.8124",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15864",
  "simple-menus-lib": "static-1.17381",
  "crm-record-cards-client": "static-1.135"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28789",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2054",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.512",
  "crm_data": "/crm_data/static-4.93273",
  "data-fetching-client": "/data-fetching-client/static-1.10145",
  "emoji-mart": "/emoji-mart/static-3.9",
  "enviro": "/enviro/static-4.523",
  "foundations-components": "/foundations-components/static-1.8798",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1823",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6096",
  "hs-test-utils": "/hs-test-utils/static-1.8547",
  "hub-http": "/hub-http/static-1.6710",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11996",
  "I18n": "/I18n/static-7.1716",
  "jasmine-runner": "/jasmine-runner/static-1.6961",
  "quartz": "/quartz/static-1.7698",
  "raven": "/raven/static-3.6411",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.123",
  "react-utils": "/react-utils/static-2.5682",
  "reselect": "/reselect/static-3.18",
  "stripe-js": "/stripe-js/static-1.122",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6133",
  "UIComponents": "/UIComponents/static-3.8942",
  "usage-tracker-public": "/usage-tracker-public/static-1.7637",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38108",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.712",
  "cssUtils": "/cssUtils/static-1.1130",
  "customer-data-objects": "/customer-data-objects/static-1.8219",
  "FireAlarmUi": "/FireAlarmUi/static-1.4894",
  "foundations-assets": "/foundations-assets/static-1.5395",
  "foundations-theming": "/foundations-theming/static-1.4998",
  "graphql": "/graphql/static-1.95",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12303",
  "icons": "/icons/static-2.710",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3389",
  "property-translator": "/property-translator/static-1.5885",
  "quartz-config": "/quartz-config/static-1.1476",
  "quartz-core": "/quartz-core/static-1.6917",
  "quartz-i18n": "/quartz-i18n/static-1.1373",
  "quartz-routing": "/quartz-routing/static-1.1128",
  "quartz-tracking": "/quartz-tracking/static-1.1077",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17243",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "ReduxMessenger": "/ReduxMessenger/static-2.10878",
  "rpc-client-utils": "/rpc-client-utils/static-1.5170",
  "sanitize-text": "/sanitize-text/static-1.8666",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5262",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11653",
  "ui-images": "/ui-images/static-2.1284",
  "usage-tracker-core": "/usage-tracker-core/static-1.7676",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3975",
  "quartz-webpack": "/quartz-webpack/static-1.3922",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.776",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "crm_universal": "/crm_universal/static-1.22768",
  "customer-data-email": "/customer-data-email/static-1.18689",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10340",
  "dispatcher": "/dispatcher/static-1.150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8427",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8266",
  "quick-fetch": "/quick-fetch/static-1.4247",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5067",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2714",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9936",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.112",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3177",
  "ui-fonts": "/ui-fonts/static-1.1258",
  "HeadJS": "/HeadJS/static-2.830",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3658",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.419",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4810",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6281",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5259",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20547",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19633",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11381",
  "crm-message-bus": "/crm-message-bus/static-1.44171",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13540",
  "customer-data-properties": "/customer-data-properties/static-1.53159",
  "growth-payments-core": "/growth-payments-core/static-1.26558",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9585",
  "usage-tracker": "/usage-tracker/static-1.7826",
  "usage-tracker-container": "/usage-tracker-container/static-1.7816",
  "sassPrefix": "/sassPrefix/static-1.391",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4168",
  "foundations-theming-base": "/foundations-theming-base/static-1.3983",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3481",
  "stylex": "/stylex/static-1.48",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.300",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hubspotter-http": "/hubspotter-http/static-1.4991",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.675",
  "quartz-auth": "/quartz-auth/static-1.1373",
  "quartz-head": "/quartz-head/static-1.1363",
  "quartz-test": "/quartz-test/static-1.1373",
  "trellis-components": "/trellis-components/static-1.3196",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5512",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.207",
  "web-vitals": "/web-vitals/static-1.21",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.580",
  "chirp-fetch": "/chirp-fetch/static-1.2409",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4974",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5219",
  "sequences-lib": "/sequences-lib/static-1.8827",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5097",
  "FileManagerCore": "/FileManagerCore/static-1.40388",
  "FileManagerLib": "/FileManagerLib/static-1.40529",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5387",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.764",
  "timezone-utils": "/timezone-utils/static-2.5734",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "react-dnd-compat": "/react-dnd-compat/static-1.5112",
  "stylex-utils": "/stylex-utils/static-1.183",
  "trellis-theming": "/trellis-theming/static-1.1528",
  "react-flip-move": "/react-flip-move/static-1.85",
  "avatar-components": "/avatar-components/static-1.2995",
  "hs-resources": "/hs-resources/static-1.694",
  "pulse": "/pulse/static-1.1160",
  "utility-belt": "/utility-belt/static-1.3042",
  "zustand": "/zustand/static-1.91",
  "batch-promise": "/batch-promise/static-1.2058",
  "customer-data-associations": "/customer-data-associations/static-1.7846",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8561",
  "customer-data-tracking": "/customer-data-tracking/static-1.7376",
  "framework-data-table": "/framework-data-table/static-2.12888",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50119",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24311",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8292",
  "ui-addon-opt": "/ui-addon-opt/static-4.8927",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10075",
  "customer-data-rte": "/customer-data-rte/static-1.33953",
  "cv-backend-services": "/cv-backend-services/static-1.1612",
  "file-manager-components": "/file-manager-components/static-1.24889",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3566",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6583",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19339",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15896",
  "payment-link-components": "/payment-link-components/static-1.24521",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5610",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39221",
  "react-colorpicker": "/react-colorpicker/static-2.10713",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18568",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9127",
  "user-context": "/user-context/static-1.5563",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2101",
  "atom": "/atom/static-1.5580",
  "reference-resolvers": "/reference-resolvers/static-1.8692",
  "calling-global-api": "/calling-global-api/static-1.66300",
  "calling-internal-common": "/calling-internal-common/static-1.31828",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67682",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59974",
  "commerce-products-lib": "/commerce-products-lib/static-1.10989",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4130",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4800",
  "crm-links": "/crm-links/static-1.6821",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4460",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10282",
  "data-agent-utils": "/data-agent-utils/static-1.979",
  "data-token-picker": "/data-token-picker/static-1.17183",
  "external-options-client-types": "/external-options-client-types/static-1.4455",
  "formula-editor": "/formula-editor/static-1.15053",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3791",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4531",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1140",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4025",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4300",
  "property-value-citations": "/property-value-citations/static-1.3773",
  "react-tinymce": "/react-tinymce/static-1.56326",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8619",
  "rich-text-lib": "/rich-text-lib/static-1.20603",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.545",
  "tiered-pricing": "/tiered-pricing/static-1.2335",
  "tinymce-config": "/tinymce-config/static-2.55452",
  "tinymce-plugins": "/tinymce-plugins/static-1.58566",
  "tinymce-themes": "/tinymce-themes/static-1.57422",
  "topics-actions-lib": "/topics-actions-lib/static-1.693",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1432",
  "trial-components-library": "/trial-components-library/static-1.14435",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10371",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "laboratory-lib": "/laboratory-lib/static-3.7655",
  "onboarding-scopes": "/onboarding-scopes/static-1.6957",
  "seat-types-lib": "/seat-types-lib/static-1.1103",
  "magpie-lib": "/magpie-lib/static-1.5933",
  "navigation-messaging": "/navigation-messaging/static-1.8556",
  "ts-schema": "/ts-schema/static-1.4411",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10955",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10953",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8684",
  "audio-components": "/audio-components/static-1.6613",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1089",
  "ContentUtils": "/ContentUtils/static-1.69547",
  "copilot-toolkit": "/copilot-toolkit/static-1.12209",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30105",
  "FileManagerImages": "/FileManagerImages/static-1.38040",
  "html-to-image": "/html-to-image/static-1.67",
  "immerable": "/immerable/static-1.4647",
  "ui-universal-auth": "/ui-universal-auth/static-1.9804",
  "urlinator": "/urlinator/static-1.5022",
  "video-components": "/video-components/static-1.14501",
  "video-data-lib": "/video-data-lib/static-1.36157",
  "video-embed": "/video-embed/static-1.36991",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.846",
  "trellis-migration-context": "/trellis-migration-context/static-1.86",
  "event-emitter": "/event-emitter/static-1.1465",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.521",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4352",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.663",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13679",
  "reporting-data": "/reporting-data/static-1.69494",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.487",
  "purchase-motions-components": "/purchase-motions-components/static-1.6674",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7089",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5592",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19625",
  "onboarding-tours": "/onboarding-tours/static-1.17436",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "chatspot-core": "/chatspot-core/static-1.24072",
  "content-assistance-lib": "/content-assistance-lib/static-1.8467",
  "draft-content-plugins": "/draft-content-plugins/static-1.29206",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22406",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2279",
  "poll-commands": "/poll-commands/static-1.3981",
  "video-components-external": "/video-components-external/static-1.12499",
  "trellis-story-utils": "/trellis-story-utils/static-1.5003",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10033",
  "content-media-capture": "/content-media-capture/static-1.5843",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9602",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10790",
  "hub-http-contrib": "/hub-http-contrib/static-1.3536",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5711",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6906",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19619",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4030",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18737",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1503",
  "calling-error-reporting": "/calling-error-reporting/static-1.31835",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11548",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7049",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7622",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2551",
  "commerce-permissions": "/commerce-permissions/static-1.1291",
  "products-iframe-lib": "/products-iframe-lib/static-1.8973",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11337",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6957",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11038",
  "sales-views-client-types": "/sales-views-client-types/static-1.4766",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7402",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10483",
  "data-agent-kit": "/data-agent-kit/static-1.966",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.320",
  "fsm": "/fsm/static-1.4266",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7310",
  "bark-lib": "/bark-lib/static-1.17039",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6403",
  "react-codemirror": "/react-codemirror/static-1.11148",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5247",
  "tinymce-data": "/tinymce-data/static-1.41537",
  "layout-dnd-components": "/layout-dnd-components/static-1.13272",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12247",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17020",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9384",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16105",
  "hubs-service-types": "/hubs-service-types/static-1.1771",
  "navigation-components": "/navigation-components/static-1.19229",
  "nest": "/nest/static-1.742",
  "nudge-client-utils": "/nudge-client-utils/static-1.3467",
  "purchase-motions-api": "/purchase-motions-api/static-1.6677",
  "signup-constants": "/signup-constants/static-1.20010",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5393",
  "reactive-lib": "/reactive-lib/static-1.1228",
  "simple-logging-lib": "/simple-logging-lib/static-1.3555",
  "nav-meta": "/nav-meta/static-1.30866",
  "breeze-engine-core": "/breeze-engine-core/static-1.1557",
  "cms-field-types": "/cms-field-types/static-1.5319",
  "content-icons-ui": "/content-icons-ui/static-1.2489",
  "integrations-lib": "/integrations-lib/static-1.17496",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.368",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1600",
  "social-insights-client-types": "/social-insights-client-types/static-1.22982",
  "outpost": "/outpost/static-1.4638",
  "persist-promise": "/persist-promise/static-1.4215",
  "reporting-client-types": "/reporting-client-types/static-1.2867",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8542",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11049",
  "immutable-less": "/immutable-less/static-1.5159",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18500",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21093",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8458",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4423",
  "growth-data-modal": "/growth-data-modal/static-1.6175",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3040",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5651",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8171",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29613",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1257",
  "highlight.js": "/highlight.js/static-1.92",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13647",
  "content-media-compositions": "/content-media-compositions/static-2.17654",
  "media-bridge-lib": "/media-bridge-lib/static-1.19687",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4934",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37328",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7307",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3878",
  "highcharts": "/highcharts/static-8.117",
  "storybook-react": "/storybook-react/static-1.46",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16719",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69622",
  "layout-data-lib": "/layout-data-lib/static-1.10572",
  "academy-common-lib": "/academy-common-lib/static-1.15566",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3224",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3543",
  "whisper-core-api": "/whisper-core-api/static-1.7682",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14911",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6132",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4115",
  "oauth-service-types": "/oauth-service-types/static-1.4644",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8637",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1704",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2881",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3068",
  "user-context-client": "/user-context-client/static-1.5017",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15865",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12607",
  "ExportDialog": "/ExportDialog/static-6.10880",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35263",
  "academy-service-client": "/academy-service-client/static-1.4200",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.85",
  "SafeStorage": "/SafeStorage/static-1.4903",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7897",
  "wootric-nps": "/wootric-nps/static-1.7314",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3522",
  "settings-ui-lib": "/settings-ui-lib/static-1.13036",
  "simple-data-table": "/simple-data-table/static-1.3876",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8124",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15864",
  "simple-menus-lib": "/simple-menus-lib/static-1.17381",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.135"
}
};
